/**
 * App-level feature switches.
 *
 * FIVE OF THESE READ THE ENVIRONMENT, AND NO DEPLOYED ENVIRONMENT SETS THEM.
 * dashboard, opportunities, community, network and events are surfaces still
 * being built. They were hardcoded `false`, so the only way to see them locally
 * was to edit this file and hide the edit with `git update-index
 * --skip-worktree` — which hid it from status and diff, but still made
 * `git pull --ff-only` abort whenever dev touched this file, with an error
 * naming a file that every inspection tool reported as unmodified.
 *
 * ABSENT MEANS OFF. Set the variables in `.env.development.local` and nowhere
 * else — not on compaire-dev, not on compaire-prod — so both deployed
 * environments behave exactly as they did when these were hardcoded `false`.
 * Not `.env.local`: vitest reads that file and would turn them on under test.
 * Same pattern and reasoning as ORG_NAV_FEATURE_FLAGS in featureFlags.ts.
 *
 * showSocialCommunity is deliberately NOT env-driven. It stays a hardcoded
 * `false`, pinned by src/lib/f006SocialOAuthGuards.test.ts: the F-006 security
 * remediation requires the Social & Community surface to be off in source, not
 * merely unconfigured, so that no environment variable can turn it on. Its
 * feed reads org_social_posts, which nothing populates, so it would render
 * empty locally anyway. Turning it on anywhere is a decision to relax F-006.
 *
 * feed, explore and showDiscoveryCalls stay compiled constants. They are on
 * everywhere on purpose.
 */
export const FEATURES = {
  dashboard: import.meta.env.VITE_FEATURE_DASHBOARD === "true",
  opportunities: import.meta.env.VITE_FEATURE_OPPORTUNITIES === "true",
  feed: true,
  community: import.meta.env.VITE_FEATURE_COMMUNITY === "true",
  explore: true,
  network: import.meta.env.VITE_FEATURE_NETWORK === "true",
  events: import.meta.env.VITE_FEATURE_EVENTS === "true",
  showDiscoveryCalls: true,
  showSocialCommunity: false,
};
